import { render } from "./AppFooter.vue?vue&type=template&id=3fc0e3e2&scoped=true"
const script = {}

import "./AppFooter.vue?vue&type=style&index=0&id=3fc0e3e2&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fc0e3e2"]])

export default __exports__